export const pageErrorMessages = {
    401: 'Acceso no autorizado',
    403: 'Acceso prohibido',
    404: 'Página no encontrada',
    500: 'Error interno del servidor',
    504: 'El servidor no respondió a tiempo',
}
export const actionErrorMessages = {
    401: 'Necesitas iniciar sesión para realizar esta acción',
    403: 'No tiene permitido realizar esta acción',
    404: 'Recurso no encontrado',
    409: 'La acción no puede realizarse debido a un conflicto con el recurso',
    500: 'Error interno del servidor',
    504: 'El servidor no respondió a tiempo',
}
export const resourceErrorMessages = {
    401: 'Necesitas iniciar sesión para acceder a este recurso',
    403: 'No tiene permitido acceder a este recurso',
    404: 'Recurso no encontrado',
    500: 'Error interno del servidor',
    504: 'El servidor no respondió a tiempo',
}
